module.exports = __webpack_public_path__ + "img/JAOC_POP_PizzaMaker_Correct.ccad4d3b.png";